import React from 'react';
import { Card, Switch, Space, Form, Row, Col, InputNumber } from 'antd';

const EFrameSettings = ({
  enable,
  motorCount,
  fis,
  fil,
  onStateChange,
  onValueChange,
}) => {
  const endNeedle = fis + fil;

  return (
    <Card
      title={
        <div>
          <Space size="middle">
            <span>电子综框</span>
            <Switch
              checkedChildren="开启"
              unCheckedChildren="关闭"
              checked={enable}
              onChange={onStateChange}
            />
          </Space>
        </div>
      }
      size="small"
      type="inner"
      bodyStyle={enable ? {} : { padding: '0' }}
    >
      {enable && (
        <Form>
          <Row>
            <Col span={8} style={{ padding: '0 10px' }}>
              <Form.Item label="电机数量">
                <InputNumber
                  controls={false}
                  style={{ width: '100%' }}
                  value={motorCount}
                  min={1}
                  onChange={(val) => {
                    onValueChange('motorCount', parseInt(val));
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ padding: '0 10px' }}>
              <Form.Item label="起始针">
                <InputNumber
                  controls={false}
                  style={{ width: '100%' }}
                  value={fis + 1}
                  onChange={(val) => {
                    onValueChange('fis', val - 1);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: '0 10px' }}>
              <Form.Item label="针长度">
                <InputNumber
                  controls={false}
                  style={{ width: '100%' }}
                  value={fil}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: '0 10px' }}>
              <Form.Item label="结束针">
                <InputNumber
                  controls={false}
                  style={{ width: '100%' }}
                  value={endNeedle}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Card>
  );
};

export default EFrameSettings;
